/**
 * Delegate event
 * Doesn't work with mouseleave
 * (the mouseleave event is triggered only when the pointer moves away from
 * the original target - which in the case of event delegating can't be the body)
 * @param String selector
 * @param Function listener
 * @param Object options
 * @returns Function
 */
function delegate(selector, listener, options) {
    return function(e) {
        options = options || {};
        let element = e.target;
        let originalTarget = e.currentTarget;
        let relatedTarget = e.relatedTarget;

        do {
            if (!(element instanceof Element) || !element.matches(selector)) {
                continue;
            }

            // simulate a mouseleave using a mouseout event
            if (e.type == 'mouseout' && options.actAsMouseLeave) {
                // loop through all parents of the related target, and make sure that it's not a child of the target (make the last parent in the DOM the current related target)
                while (relatedTarget && relatedTarget != element && relatedTarget != document) {
                    relatedTarget = relatedTarget.parentNode;
                }

                // if the last related target is the same as the element, continue
                if (relatedTarget == element) {
                    continue;
                }
            }

            e.delegateTarget = element;
            listener.apply(this, arguments);
            return;
        } while (element = element.parentNode)
    };
}



/**
 * Get valid JSON
 * @param String string
 * @return Object | false
 */
function getValidJSON(string) {
    try {
        return JSON.parse(string);
    } catch (e) {
        return false;
    }
}



/**
 * Determines if a form control is dirty by comparing the current value with its default value
 *
 * @param Element control
 * @param String exclude - css selector/s to exclude when checking
 * @return Boolean true | false
 */
function isDirty(element, exclude) {
    let controlSelectors = ['input', 'select', 'textarea'];
    let controls = (controlSelectors.indexOf(element.nodeName.toLowerCase()) > -1) ? [element] : element.querySelectorAll(controlSelectors.join(','));
    controls = Array.prototype.slice.call(controls);

    return controls.some(checkDirtiness);

    /**
     * Check dirtiness of control element
     * @param Element control
     * @return Boolean
     */
    function checkDirtiness(control) {
        if (control.matches(exclude)) {
            return false;
        }

        if (control.type == 'checkbox' || control.type == 'radio') {
            return (control.checked != control.defaultChecked) ? true : false;
        } else if (control.type == 'select-one' || control.type == 'select-multiple') {
            for (let a = 0; a < control.options.length; a++) {
                if (control.options[a].selected != control.options[a].defaultSelected) {
                    return true;
                }
            }
            return false;
        }

        return (control.value != control.defaultValue) ? true : false;
    }
}


/**
 * Is in viewport
 * @param Element element
 * @return Bool If the element passed is in the viewport or not
 */
var isInViewport = function(element) {
    let rectangularData = element.getBoundingClientRect();

    return rectangularData.bottom > 0 &&
        rectangularData.right > 0 &&
        rectangularData.left < window.innerWidth &&
        rectangularData.top < window.innerHeight;
};


/**
 * Deep merge two objects (source: https://stackoverflow.com/a/34749873)
 * Doesn't support functions
 * @param target
 * @param ...sources
 */
function merge(target, ...sources) {
    if (!sources.length) return target;
    const source = sources.shift();

    if (isObject(target) && isObject(source)) {
        for (const key in source) {
            if (isObject(source[key])) {
                if (!target[key]) Object.assign(target, { [key]: {} });
                merge(target[key], source[key]);
            } else {
                Object.assign(target, { [key]: source[key] });
            }
        }
    }

    return merge(target, ...sources);
}


/**
* Simple object check (source: https://stackoverflow.com/a/34749873)
* @param item
* @returns {boolean}
*/
function isObject(item) {
    return (item && typeof item === 'object' && !Array.isArray(item));
}
